export interface SequoiaUploadForm {
  files: File[];
}

export const defaultValues: SequoiaUploadForm = {
  files: [],
};
